import {
  faCheckCircle,
  faClock,
  faQuestionCircle,
  faSearchDollar
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider } from "antd";
import React from "react";
import { Button, Col, Container, FormLabel, Modal, Row } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import { labels } from "../../../../localization/labels";
import { constants } from "../../../../utils/Constants";
import SecurityUtils from "../../../../utils/SecurityUtils";
import ComponentHeader from "../../../core/ComponentHeader/ComponentHeader";
import KnowledgeItemsLookup from "../../Lookups/KnowledgeItemsLookup";
import SubmitControl from "../../../core/SubmitControl";

const indexOne = props => {
  return (
    <div className="actionBlockCol">
      <Row>
        <Col sm="3">
          <FormLabel className="Label">{labels.chooseEntity}</FormLabel>
        </Col>
        <Col>
          <KnowledgeItemsLookup
            onChange={props.onChange}
            controlId="selectedEntity"
            selected={props.selectedEntity}
            messageHandler={props.messageHandler}
            breadcrumbsHandler={props.breadcrumbsHandler}
          />
        </Col>
      </Row>
      {indexingBlock(
        props.indexingFinishedOne,
        props.onStartIndexingOne,
        props.onChange,
        props.withAttachmentOne,
        "withAttachmentOne",
        props.selectedEntity
      )}
    </div>
  );
};

const indexingProgress = indexingFinished => {
  if (indexingFinished === undefined) {
    return <FontAwesomeIcon icon={faQuestionCircle} size="3x" />;
  } else {
    if (indexingFinished) {
      return <FontAwesomeIcon color="green" icon={faCheckCircle} size="3x" />;
    } else {
      return <FontAwesomeIcon color="orange" icon={faClock} size="3x" />;
    }
  }
};

const indexingBlock = (
  indexingFinished,
  onStartIndexing,
  onWithAttachmentChange,
  withAttachment,
  withAttachmentControlId,
  visible
) => {
  const rowClass = !visible ? "hidden-but-with-space" : undefined;

  return (
    <Row className={rowClass}>
      <Col>
        <div className="actionBlock">
          <div
            className={
              indexingFinished
                ? "actionBlockText actionText-clickable"
                : "actionBlockText"
            }
          >
            <SubmitControl
              value={withAttachment}
              type="checkbox"
              onChange={onWithAttachmentChange}
              title={labels.withAttachment}
              disabled={!indexingFinished}
              controlId={withAttachmentControlId}
            />
          </div>
          <div
            className={
              indexingFinished
                ? "actionBlockIcon actionBlock-clickable"
                : "actionBlockIcon"
            }
            onClick={indexingFinished ? onStartIndexing : undefined}
          >
            <FontAwesomeIcon icon={faSearchDollar} size="3x" color="#007bff" />
          </div>
          <div
            className={
              indexingFinished
                ? "actionBlockText actionText-clickable"
                : "actionBlockText"
            }
          >
            {labels.startIndexing}
          </div>
        </div>
      </Col>
      <Col>
        <div className="actionBlock">
          <div className="actionBlockIcon actionBlockStatus">
            {indexingProgress(indexingFinished)}
          </div>
          <div className="actionBlockText actionBlockTextStatus">
            {labels.indexingStatus}
          </div>
        </div>
      </Col>
    </Row>
  );
};

const reindexing = props => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <ComponentHeader title={labels.system}></ComponentHeader>
        <Container className="bordered_bottom_rounded system_padding_removed">
          <Divider orientation="left">{labels.searchSettings}</Divider>
          <Row className="justify-content-md-center">
            <Col md="auto" className="actionBlockContainer">
              <div className="system-reindex-block">
                <Row className="justify-content-md-center">
                  <Col className="colContainer">
                    <FormLabel className="Label">
                      {labels.reindexAllTitle}
                    </FormLabel>
                  </Col>
                </Row>
                {indexingBlock(
                  props.indexingFinished,
                  props.onStartIndexingAll,
                  props.onChange,
                  props.withAttachmentAll,
                  "withAttachmentAll",
                  true
                )}
              </div>
            </Col>
            <Col md="auto" className="actionBlockContainer">
              <div className="system-reindex-block">
                <Row className="justify-content-md-center">
                  <Col className="colContainer">
                    <FormLabel className="Label">
                      {labels.reindexOneTitle}
                    </FormLabel>
                  </Col>
                </Row>
                {indexOne(props)}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

const System = props => {
  return (
    <>
      {SecurityUtils.partyHasAnyOfProcessesOrSameParty([
        constants.OPERATION_REINDEX_ALL
      ])
        ? reindexing(props)
        : null}
      <Modal show={props.modal.show} onHide={props.onModalClose}>
        <ModalHeader closeButton>
          <Modal.Title>{props.modal.title}</Modal.Title>
        </ModalHeader>
        <Modal.Body>{props.modal.body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onModalClose}>
            {labels.cancel}
          </Button>
          <Button variant="primary" onClick={props.modal.action}>
            {labels.ok}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default System;
